export const SUBSCRIPTION_URL = `user-access/subscriptions`;

export const SUBSCRIPTION_STATUS_DESCRIPTIONS = {
  active: 'Abonnement actif',
  past_due: 'En attente de moyen de paiement.',
  unpaid: 'Abonnement non renouvelé.',
  canceled: 'Abonnement annulé.',
  incomplete: 'Des informations sont manquantes pour finaliser votre Abonnement.',
  incomplete_expired: 'Abonnement non finalisé.',
  trialing: "Periode d'essai en cours",
};
